import type { BusinessHour } from '../types/storefront'

export const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

/** "09:00" -> "9am", "17:30" -> "5:30pm". Nothing locale-aware is needed: the
 *  backend hands back plain wall-clock strings in the vendor timezone. */
export function formatClock(value: string | null): string {
  if (!value) return ''
  const [rawH, rawM] = value.split(':')
  const hour = Number(rawH)
  const minute = Number(rawM ?? 0)
  if (Number.isNaN(hour)) return value
  const suffix = hour < 12 ? 'am' : 'pm'
  const display = hour % 12 === 0 ? 12 : hour % 12
  return minute ? `${display}:${String(minute).padStart(2, '0')}${suffix}` : `${display}${suffix}`
}

export function formatBusinessHour(hour: BusinessHour): string {
  if (!hour.is_open || !hour.open_time || !hour.close_time) return 'Closed'
  return `${formatClock(hour.open_time)} - ${formatClock(hour.close_time)}`
}

/** Footer summary: the week ordered Monday-first, which is how the Stitch
 *  "Hours" column reads, with Sunday moved to the end. */
export function weekOrdered(hours: BusinessHour[]): BusinessHour[] {
  return [...hours].sort((a, b) => ((a.day + 6) % 7) - ((b.day + 6) % 7))
}
